import Stack from '@mui/material/Stack';
import React, {useEffect, useState} from 'react';

import {CodeValidationForm} from 'presentation/pages/public/components';
import {PublicFlowEnum} from 'presentation/pages/public/constants/PublicFlowEnum';
import {NeedHelpDialog} from '../../NeedHelpDialog';
import {LOCAL_STORAGE_KEYS} from '../../../constants/localStorageKeys';

export function Step2Form() {
	const [showNeedHelp, setShowNeedHelp] = useState(false);

	useEffect(() => {
		const cameFromStep1 = localStorage.getItem(LOCAL_STORAGE_KEYS.CAME_FROM_SEND_STEP);
		if (cameFromStep1 === 'true') {
			setShowNeedHelp(true);
			localStorage.removeItem(LOCAL_STORAGE_KEYS.CAME_FROM_SEND_STEP);
		}
	}, []);

	return (
		<Stack gap={2}>
			{showNeedHelp && <NeedHelpDialog />}
			<CodeValidationForm flowType={PublicFlowEnum.FORGOT_PASSWORD} />
		</Stack>
	);
}
